<template>
  <BaseCard
    :result="{
      orgName: searchResult.secondary_organization.name,
      orgLink: searchResult.link,
      tagName: $t(`search.articles.tagName`),
      tagLink: `${searchResult.link}/news`,
      id: searchResult.id,
      type: searchResult.type,
      result_position: resultPosition,
      display_text: searchResult.title,
    }"
    class="news-card result-card"
    @result-clicked="handleResultClick"
  >
    <template #preview>
      <div
        v-if="searchResult?.image_url"
        class="preview-image"
      >
        <img
          :src="searchResult.image_url"
          :alt="searchResult.alt_text"
        />
      </div>
      <div
        v-else
        class="preview-fallback"
      >
        <Icon
          name="lucide:newspaper"
          size="24"
        />
      </div>
    </template>
    <template #result-content>
      <a
        :href="url"
        class="title"
        @click.stop="handleResultClick"
        >{{ searchResult.title }}</a
      >
      <div
        v-if="searchResult.snippet"
        class="snippet"
      >
        {{ searchResult.snippet }}
      </div>
      <PublishedUpdatedDate :search-result="searchResult" />
    </template>
  </BaseCard>
</template>

<script setup>
import BaseCard from './BaseCard.vue';
import PublishedUpdatedDate from './PublishedUpdatedDate.vue';

const props = defineProps({
  searchResult: {
    type: Object,
    default: () => ({}),
  },
  resultPosition: {
    type: Number,
    required: true,
  },
});

const emit = defineEmits(['result-clicked']);

const url = computed(() => {
  return `${props.searchResult.link}/article/${props.searchResult.id}`;
});

async function handleResultClick() {
  await navigateTo(url.value, { external: true });
  emit('result-clicked', {
    position: props.resultPosition,
    url: url.value,
  });
}
</script>

<style scoped>
.news-card {
  --background-color: #f3fafc;
  --text-color: #0592cc;
}
.news-card .snippet {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.4;
}
.news-card .title {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.4;
}
</style>
